import { getOS } from '@helpers/osDetection';

interface IDiagnosticDetails {
  [key:string]: any;
}

export function isReportableSubscriptionStoreError(error:any):boolean {
  if (!error) {
    return true;
  }

  // Closing the App Store / Google Play purchase sheet is expected user behaviour,
  // not an application or store failure that needs operational attention.
  return error.code !== CdvPurchase.ErrorCode.PAYMENT_CANCELLED;
}

function normalizeError(error:any):IDiagnosticDetails|undefined {
  if (!error) {
    return undefined;
  }

  return {
    code: error.code,
    message: error.message || String(error),
    platform: error.platform,
    productId: error.productId,
  };
}

export function createSubscriptionStoreDiagnostic(
  stage:string,
  productId:string,
  platform:CdvPurchase.Platform|undefined,
  error?:any,
  details?:IDiagnosticDetails,
):string {
  try {
    const store = typeof CdvPurchase !== "undefined" ? CdvPurchase.store : undefined;
    const device = (globalThis as any).device;
    let orderSupported:boolean|undefined;
    let storefront:string|undefined;

    if (store && platform) {
      const adapter = store.getAdapter(platform);
      if (adapter) {
        orderSupported = adapter.checkSupport("order");
      }
      // The store account's country: the App Store can answer that a product doesn't exist in it.
      const platformStorefront = store.getStorefront(platform);
      storefront = platformStorefront ? platformStorefront.countryCode : undefined;
    }

    const products = store && store.products
      ? store.products.map((product:CdvPurchase.Product) => ({
          id: product.id,
          platform: product.platform,
          type: product.type,
          offerCount: product.offers ? product.offers.length : 0,
          canPurchase: product.canPurchase,
          owned: product.owned,
        }))
      : [];

    return "Subscription store diagnostic: " + JSON.stringify({
      // 2: the storefront, and store errors with the StoreKit / Google Play details the patched plugin adds.
      diagnosticVersion: 2,
      stage,
      productId,
      requestedPlatform: platform,
      detectedOS: getOS(),
      pluginVersion: typeof CdvPurchase !== "undefined" ? CdvPurchase.PLUGIN_VERSION : undefined,
      storeReady: store ? store.isReady : false,
      storefront,
      orderSupported,
      loadedProducts: products,
      device: device ? {
        platform: device.platform,
        version: device.version,
        model: device.model,
      } : undefined,
      error: normalizeError(error),
      details,
    });
  } catch (diagnosticError) {
    return "Subscription store diagnostic: " + JSON.stringify({
      diagnosticVersion: 2,
      stage,
      productId,
      requestedPlatform: platform,
      diagnosticError: normalizeError(diagnosticError),
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/subscription/subscriptionDiagnostics.ts